import { Directive } from '@angular/core';
@Directive({ selector: 'time'})
export class TimeDirective {}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/utils/time.directive.ts